import { useAtomValue } from 'jotai';
import { accountsTariffSummaryAtom } from 'src/atoms/filters/tariff-summary';
import { useAuth } from 'src/auth/hooks/useAuth';
import { useIsCslUser } from 'src/auth/hooks/useIsCslUser';

export const useTariffAccountRef = () => {
  const { user } = useAuth();
  const isCSLUser = useIsCslUser();

  const accountRef = useAtomValue(accountsTariffSummaryAtom);

  return isCSLUser ? accountRef : user.referenceId;
};
